<div *ngIf="sitioNoDisponible" class="iframe-wrapper">
    <div class="logo" style="width: 140px; max-height: 140px; margin-top: 20px">
        <img src="./../../../assets/system/logo_sidebar_resized.png" alt="logo"
            style="max-width: 100%; max-height: 100%;">
    </div>
    <h1 class="title">Sitio no disponible</h1>
</div>

<div *ngIf="!sitioNoDisponible" class="iframe-wrapper">
    <div class="logo" style="width: 140px; max-height: 100px; margin-top: 20px">
        <img src="./../../../assets/system/logo_sidebar_resized.png" alt="logo"
            style="max-width: 100%; max-height: 100%;">
    </div>
    <h1 class="title">Reserva tu Cita</h1>
    <label *ngIf="nombreEmpresa && !completado" class="default-text"> Está realizando el proceso de reserva de cita con
        la empresa
        <b>{{ nombreEmpresa }}</b>.
    </label>

    <!-- Temporizador de sesión -->
    <div *ngIf="pasoActual > 0 && !sesionExpirada && !ocultarTiempoRestante && !completado"
        class="alert alert-info d-flex align-items-center justify-content-center gap-2 mb-2"
        [ngClass]="{'alert-warning': tiempoRestante < 300, 'alert-danger': tiempoRestante < 60}">
        <span style="font-size: 1.2rem;">⏱️</span>
        <span>Tiempo restante: <strong>{{ tiempoFormateado }}</strong></span>
    </div>

    <!-- Banner de cita reservada -->
    <div *ngIf="pasoActual > 0 && completado"
        class="alert alert-success d-flex align-items-center justify-content-center gap-2 mb-2">
        <span style="font-size: 1.2rem;">✅</span>
        <span>¡Cita reservada con éxito!</span>
    </div>

    <!-- Mensaje de sesión expirada -->
    <div *ngIf="sesionExpirada && pasoActual > 0 && !completado" class="alert alert-danger text-center mb-2">
        <strong>⚠️ Tu sesión ha expirado.</strong> Por favor, recarga la página para comenzar nuevamente.
    </div>

    <div *ngIf="pasoActual == 0 && !completado" class="step-content">
        <p class="default-text">¡Bienvenido al proceso de reserva de cita!</p>
        <p class="default-text"> El proceso consta de 5 breves pasos y cuenta con un máximo de 10 minutos para su
            realización.</p>
        <!--ul>
            <li>Selección de sucursal</li>
            <li>Ingreso de información personal</li>
            <li>Selección del motivo de la cita</li>
            <li>Elección de fecha y hora</li>
            <li>Confirmación de la cita</li>
        </ul-->
        <p class="default-text">Por favor, asegúrate de contar con la información de tu vehículo y tus datos de contacto
            antes de comenzar.</p>
    </div>

    <div *ngIf="pasoActual == 1 && !completado" class="step-content">
        <p class="step-text">Paso 1: Selección de sucursal</p>
        <p class="default-text">Seleccione la sucursal que desea reservar su cita.</p>
        <div class="mb-3">
            <select class="form-select" [(ngModel)]="sucursalSeleccionada" (ngModelChange)="onChangeSucursal()">
                <option *ngFor="let sucursal of sucursales" [value]="sucursal.id">{{ sucursal.nombre }}</option>
            </select>
        </div>
    </div>

    <div *ngIf="pasoActual == 2 && !completado" class="step-content">
        <p class="step-text">Paso 2: Ingrese su información</p>
        <p class="default-text">Indique su nombre, apellido, correo electrónico y patente de vehículo.</p>
        <div class="mb-3">
            <div class="d-flex flex-row gap-2 w-100">
                <div class="d-flex flex-column w-100">
                    <label>Nombre:</label>
                    <input type="text" class="form-control" id="nombre" [(ngModel)]="nombreCliente"
                        placeholder="Ingrese su nombre">
                </div>
                <div class="d-flex flex-column w-100">
                    <label>Apellido:</label>
                    <input type="text" class="form-control" id="apellido" [(ngModel)]="apellidoCliente"
                        placeholder="Ingrese su apellido">
                </div>
            </div>

            <div class="d-flex flex-column my-3 w-100">
                <label>Correo electrónico:</label>
                <input type="email" class="form-control" id="email" [(ngModel)]="emailCliente"
                    placeholder="Ingrese su correo electrónico">
            </div>

            <div class="d-flex flex-column w-100">
                <label>Patente de Vehículo:</label>
                <input type="text" class="form-control" id="patente" [(ngModel)]="patenteVehiculo"
                    placeholder="Ingrese la patente de su vehículo">
            </div>
        </div>
    </div>

    <div *ngIf="pasoActual == 3 && !completado" class="step-content">
        <p class="step-text">Paso 3: Motivo de la cita</p>
        <p class="default-text">Seleccione el motivo de su cita.</p>
        <div class="mb-3">
            <select class="form-select" [(ngModel)]="motivoSeleccionado" (ngModelChange)="onChangeMotivo()">
                <option *ngFor="let motivo of motivos" [value]="motivo.id">{{ motivo.nombre }}</option>
            </select>
        </div>
    </div>

    <div *ngIf="pasoActual == 4 && !completado" class="step-content">
        <p class="step-text">Paso 4: Selección de fecha y hora</p>
        <p class="default-text">Seleccione la fecha y hora para su cita.</p>

        <!-- Selector de fecha -->
        <div class="mb-3">
            <label class="form-label fw-bold">Fecha de la cita:</label>
            <input type="date" class="form-control" [(ngModel)]="fechaSeleccionada" (change)="fechaCambiada()" [min]="fechaMinima">
        </div>

        <!-- Selector de hora visual -->
        <div class="mb-3" *ngIf="fechaSeleccionada">
            <label class="form-label fw-bold">Hora de la cita:</label>
            <p class="text-muted small">
                Seleccione una hora disponible (bloques de {{duracionReunion}} minutos)
                <span *ngIf="cantidadHorasDisponibles > 0" class="text-success">
                    - {{ cantidadHorasDisponibles }} bloques disponibles
                </span>
                <span *ngIf="cantidadHorasDisponibles === 0" class="text-danger">
                    - No hay bloques disponibles para esta fecha
                </span>
            </p>

            <div class="horas-grid" *ngIf="horasDisponibles.length > 0">
                <button *ngFor="let hora of horasDisponibles" class="hora-btn"
                    [class.selected]="isHoraSeleccionada(hora)" [class.blocked]="isHoraBloqueada(hora)"
                    [disabled]="isHoraBloqueada(hora)" (click)="seleccionarHora(hora)" type="button">
                    {{ hora }}
                </button>
            </div>

            <div *ngIf="horasDisponibles.length === 0" class="alert alert-warning mt-2">
                <i class="fas fa-exclamation-triangle me-2"></i>
                Por favor, seleccione una fecha para ver los horarios disponibles.
            </div>

            <div class="legend mt-2 d-flex gap-3 justify-content-center">
                <div class="legend-item">
                    <span class="legend-box available"></span>
                    <span class="legend-text">Disponible</span>
                </div>
                <div class="legend-item">
                    <span class="legend-box selected"></span>
                    <span class="legend-text">Seleccionada</span>
                </div>
                <div class="legend-item">
                    <span class="legend-box blocked"></span>
                    <span class="legend-text">No disponible</span>
                </div>
            </div>

            <div class="d-flex justify-content-center w-100">
                <div *ngIf="horaSeleccionada" class="alert alert-info mt-2 text-center">
                    <i class="fas fa-info-circle me-2"></i>
                    <strong>Hora seleccionada:</strong> {{ horaSeleccionada }} Hrs.
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="pasoActual == 5 && !completado" class="step-content">
        <p class="step-text">Paso 5: Confirmación de la cita</p>
        <p class="default-text">Por favor, confirme los detalles de su cita.</p>
        <div class="confirmation-details mb-3">
            <label><strong>Empresa:</strong> {{ nombreEmpresa }}</label>
            <label><strong>Sucursal:</strong> {{ sucursalSeleccionadaNombre }}</label>
            <label><strong>Nombre:</strong> {{ nombreCliente }} {{ apellidoCliente }}</label>
            <label><strong>Correo electrónico:</strong> {{ emailCliente }}</label>
            <label><strong>Patente del vehículo:</strong> {{ patenteVehiculo }}</label>
            <label><strong>Motivo de la cita:</strong> {{ motivoSeleccionadoNombre }}</label>
            <label><strong>Fecha y hora:</strong> {{ formatterService.dateFormat(fechaSeleccionada?.toLocaleString()!)
                }} a
                las {{ horaSeleccionada }} Hrs.</label>
        </div>
    </div>

    <div *ngIf="completado" class="step-content">
        <p class="default-text">Se ha registrado su solicitud de cita.</p>
        <div class="confirmation-details mb-3">
            <label><strong>Empresa:</strong> {{ nombreEmpresa }}</label>
            <label><strong>Sucursal:</strong> {{ sucursalSeleccionadaNombre }}</label>
            <label><strong>Nombre:</strong> {{ nombreCliente }} {{ apellidoCliente }}</label>
            <label><strong>Correo electrónico:</strong> {{ emailCliente }}</label>
            <label><strong>Patente del vehículo:</strong> {{ patenteVehiculo }}</label>
            <label><strong>Motivo de la cita:</strong> {{ motivoSeleccionadoNombre }}</label>
            <label><strong>Fecha y hora:</strong> {{ formatterService.dateFormat(fechaSeleccionada?.toLocaleString()!)
                }} a
                las {{ horaSeleccionada }} Hrs.</label>
        </div>
        <p class="default-text">Se ha enviado un correo electrónico con la información de su cita.</p>
    </div>

    <div *ngIf="pasoActual == 0 && !completado">
        <button type="button" class="btn btn-next" (click)="nextStep()">{{
            isLastStep ? 'Confirmar' : pasoActual == 0 ? 'Iniciar' : 'Siguiente' }}</button>
    </div>

    <div class="iframe-buttons" *ngIf="pasoActual != 0 && !completado">
        <button type="button" class="btn btn-back" (click)="prevStep()">Atrás</button>
        <button type="button" class="btn btn-next" (click)="nextStep()">{{
            isLastStep ? 'Confirmar' : 'Siguiente' }}</button>
    </div>
</div>